import { generateBaseQueryKeysList } from '@/queries/utils';

export const OPOBFF_ORGANIZATION_KEYS = {
  main: 'opobffOrganizations',
};

export const opobffOrganizationQueryKeys = generateBaseQueryKeysList(OPOBFF_ORGANIZATION_KEYS.main);
